import { render, staticRenderFns } from "./ImageModal.vue?vue&type=template&id=83ba5532&scoped=true&"
import script from "./ImageModal.vue?vue&type=script&lang=js&"
export * from "./ImageModal.vue?vue&type=script&lang=js&"
import style0 from "./ImageModal.vue?vue&type=style&index=0&id=83ba5532&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83ba5532",
  null
  
)

export default component.exports